'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AnchorBibSelector = require('./components/AnchorBibSelector.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AnchorBibSelector).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/user-list/lib/components/anchor-bib-selector/index.js
// module id = 1034
// module chunks = 0